import type { AppRoute } from "@/lib/routing";
import { MaterialsPage } from "./MaterialsPage";

export const routes: AppRoute[] = [
  {
    path: "/materials",
    element: <MaterialsPage />,
    handle: {
      title: "Materials",
      keywords: ["raw materials", "ingredients", "CAS", "molecules", "naturals", "synonyms"],
    },
  },
  {
    path: "/materials/:id",
    lazy: async () => ({ Component: (await import("./MaterialDetailPage")).MaterialDetailPage }),
    handle: { title: "Material" },
  },
];
